export enum TypeNotification {
  NEWS = 'NEWS',
  EVENTS = 'EVENTS',
  ROOMS_MESSAGES = 'ROOMS_MESSAGES',
  USERS_MESSAGES = 'USERS_MESSAGES',
  ARRIVALS = 'ARRIVALS'
}
